import { Box, Tabs } from '@mantine/core';
import { IconMap2, IconNotes } from '@tabler/icons-react';
import type { ReactNode } from 'react';
import { useState } from 'react';
import { PillTabList } from '../../../shared/ui/PillTabList';
import type { HubsView } from '../types/hubs';
import { LocsMapStage } from './LocsMapStage';

type HubsStageProps = {
  postsStage: (viewSwitcher: ReactNode) => ReactNode;
  apiBase: string;
  cdnBase: string;
  onStartConversation: (authorUserId: number) => void;
  onViewProfile: (authorUserId: number) => void;
};

export function HubsStage({
  postsStage,
  apiBase,
  cdnBase,
  onStartConversation,
  onViewProfile,
}: HubsStageProps) {
  const [activeView, setActiveView] = useState<HubsView>('map');
  const [hasOpenedPosts, setHasOpenedPosts] = useState(false);
  const [mapRefreshKey, setMapRefreshKey] = useState(0);

  const handleViewChange = (value: string | null) => {
    const nextView = (value ?? 'map') as HubsView;
    if (nextView === 'posts') {
      setHasOpenedPosts(true);
    }
    if (nextView === 'map' && activeView !== 'map') {
      setMapRefreshKey((k) => k + 1);
    }
    setActiveView(nextView);
  };

  const viewSwitcher = (
    <PillTabList
      aria-label="Hubs 内容视图"
      width={82}
      items={[
        { value: 'map', 'aria-label': '地图', title: '地图', children: <IconMap2 size={18} stroke={2} /> },
        { value: 'posts', 'aria-label': '文章', title: '文章', children: <IconNotes size={18} stroke={2} /> },
      ]}
    />
  );


  return (
    <Box className="hubs-stage" data-testid="hubs-stage">
      <Tabs
        value={activeView}
        onChange={handleViewChange}
        className="hubs-stage__tabs"
        variant="pills"
      >
        <Tabs.Panel value="posts" className="hubs-stage__panel">
          {hasOpenedPosts ? postsStage(activeView === 'posts' ? viewSwitcher : null) : null}
        </Tabs.Panel>
        <Tabs.Panel value="map" className="hubs-stage__panel">
          <LocsMapStage
            apiBase={apiBase}
            cdnBase={cdnBase}
            active={activeView === 'map'}
            viewSwitcher={activeView === 'map' ? viewSwitcher : null}
            onStartConversation={onStartConversation}
            onViewProfile={onViewProfile}
            refreshKey={mapRefreshKey}
          />
        </Tabs.Panel>
      </Tabs>
    </Box>
  );
}
